import React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { connect } from '../../Store';
import { Icon } from 'oxyrion-ui/lib';
import { ResponsiveTabs, Title } from '../ReusableComponents';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: ${rem(690)};
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: start;
  padding-top: ${rem(20)};
`;

const Box = styled(ResponsiveTabs)`
  width: ${rem(400)};
  font-size: 12px;
  font-weight: 500;
  color: #6b6b68;
  justify-content: center;
  align-items: center;
  text-align: center;
  background:  ${props =>
    props.selected ? 'white' : ({ theme }) => theme.segment.secondaryBg}
  padding: ${props => (props.selected ? rem(3) : rem(5))};
  margin: ${rem(3)};
  flex-direction: column;
  padding-bottom: ${rem(40)};
  padding-top: ${props => (props.selected ? '0' : rem(60))};
  border: ${props => (props.selected ? rem(2) : '0')} solid
    ${({ theme }) => theme.color.primary};
    cursor: pointer;
 &:hover{
     ${props => {
       if (!props.selected) {
         return css`
             background: white;
             padding: ${rem(3)};
             padding-top: ${rem(58)};
             padding-bottom: ${rem(38)};
             border: ${rem(2)}  solid
             ${({ theme }) => theme.color.primary};
             }
             `;
       }
       return css``;
     }}
  
`;

const AddBox = styled(ResponsiveTabs)`
  width: ${rem(200)};
  margin: ${rem(5)};
  font-size: 12px;
  font-weight: 500;
  color: #6b6b68;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  background: white;
  cursor: pointer;
  min-height: ${rem(200)};
  &:hover {
    border: ${rem(2)} solid ${({ theme }) => theme.color.primary};
    margin: ${rem(3)};
  }
`;
const IconWrapper = styled.div`
  height: ${rem(60)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AddNewTitle = styled.div`
  max-width: ${rem(150)};
  display: flex;
  font-size: ${rem(20)};
  align-items: center;
  text-align: center;
  font-weight: 500;
`;

// const DeleteWrapper = styled.div`
//   z-index: 9000;
//   width: 100%;
//   height: ${rem(16)};
//   display: flex;
//   justify-content: flex-end;
// `;

class TabsSelector extends React.Component {
  render() {
    const {
      title,
      contents,
      selected,
      addTitle,
      onSelect,
      onAddNew,
      // onDelete,
    } = this.props;
    return (
      <Wrapper>
        <Title>{title}</Title>
        <ContentWrapper>
          {contents.map((tab, index) => {
            return (
              <Box
                selected={selected === index}
                onClick={() => onSelect(index)}
              >
                {/* <DeleteWrapper>
                  <Icon
                    name="close"
                    size="l"
                    color="red"
                    onClick={() => onDelete(index)}
                  />
                </DeleteWrapper> */}
                {selected === index && (
                  <IconWrapper>
                    <Icon name="done" size="xl" color="green" />
                  </IconWrapper>
                )}
                {tab}
              </Box>
            );
          })}
          <AddBox onClick={() => onAddNew()}>
            <IconWrapper>
              <Icon name="plus" size="xl" color="green" />
            </IconWrapper>
            <AddNewTitle>{addTitle}</AddNewTitle>
          </AddBox>
        </ContentWrapper>
      </Wrapper>
    );
  }
}

TabsSelector.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.node),
  title: PropTypes.string,
  addTitle: PropTypes.string,
  selected: PropTypes.number,
  onSelect: PropTypes.func,
  onAddNew: PropTypes.func,
  onDelete: PropTypes.func,
};

TabsSelector.defaultProps = {
  contents: [],
  title: '',
  addTitle: '',
  selected: 0,
  onSelect: () => {},
  onAddNew: () => {},
  onDelete: () => {},
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(TabsSelector);



// WEBPACK FOOTER //
// ./src/Components/TabsSelector/index.jsx